import { render, staticRenderFns } from "./UserData.vue?vue&type=template&id=76e85ede&scoped=true&"
import script from "./UserData.vue?vue&type=script&lang=ts&"
export * from "./UserData.vue?vue&type=script&lang=ts&"
import style0 from "./UserData.vue?vue&type=style&index=0&id=76e85ede&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e85ede",
  null
  
)

/* custom blocks */
import block0 from "./UserData.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports